import React from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import css from "./MenuSingleItemModal.module.css";
import { menuMenuActions } from "../../../../store/slices/menu-slices";
import { menuMenuService } from "../../../../services/menu-services/menuMenu.service";
import { ImageReusable } from "../../../../ui";

const MenuSingleItemModal = ({ dish, setIsOpen }) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const { idPackForBack, idPackMealForBack, idMatching, menuMenuPacksArray } =
    useSelector((store) => store.menuMenu);
  const { dataOfDay } = useSelector((store) => store.availableDishes);

  const {
    dishId,
    dish: {
      name,
      categories,
      price,
      cost,
      weight,
      weightNetto,
      img,
      energy,
      proteins,
      fats,
      carbs,
    },
  } = dish;

  const currentLanguage = i18n.language;
  const displayName = name?.[currentLanguage] || name?.["en"] || "Unknown Dish";
  const categoryName =
    categories
      .map((category) => category.name[currentLanguage] || category.name["en"])
      .join(", ") || t("unknown-category");

  const addMenuDish = async () => {
    try {
      const formatedData = {
        date: dataOfDay,
        mealId: idPackMealForBack,
        packId: idPackForBack,
        dishId: dishId,
      };

      // Захист: чи існує поточна страва в цьому пакеті та mealId
      const currentPack = menuMenuPacksArray.find(
        (p) => p.id === idPackForBack
      );
      const alreadyExists = currentPack?.menuDishes?.some(
        (d) => d.mealId === idPackMealForBack
      );

      if (idMatching && alreadyExists) {
        await menuMenuService.updateMenuPack(idMatching, formatedData);
      } else {
        await menuMenuService.createMenuPack(formatedData);
      }

      dispatch(menuMenuActions.changeTrigger());
      dispatch(menuMenuActions.changeIdMatching("")); // обов'язково очистити!
      setIsOpen(false);
      toast.success("successfully");
    } catch (error) {
      console.error(t("modal-toast-creating-error"), error);
      toast.error(t("modal-toast-creating-error"));
    }
  };

  return (
    <div className={css.wrap} onClick={addMenuDish}>
      <div className={css.image}>
        <ImageReusable src={img} className={css.imageTag} alt="Food Image" />
      </div>

      <div className={css.name}>
        <div className={css.nameText}>{displayName}</div>
        <div className={css.nutritionInfo}>
          <span className={css.nutritionItem}>
            <span className={css.nutritionLabel}>Energy:</span>
            <span className={css.nutritionValue}>{energy || 0} kcal</span>
          </span>
          <span className={css.nutritionItem}>
            <span className={css.nutritionLabel}>P:</span>
            <span className={css.nutritionValue}>{proteins || 0}g</span>
          </span>
          <span className={css.nutritionItem}>
            <span className={css.nutritionLabel}>F:</span>
            <span className={css.nutritionValue}>{fats || 0}g</span>
          </span>
          <span className={css.nutritionItem}>
            <span className={css.nutritionLabel}>C:</span>
            <span className={css.nutritionValue}>{carbs || 0}g</span>
          </span>
        </div>
      </div>
      <div className={css.category}>{categoryName}</div>
      <div className={css.weight}>{weight}</div>
      <div className={css.weightNetto}>{weightNetto || 0}</div>
      <div className={css.cost}>{cost}</div>
      <div className={css.price}>{price}</div>
    </div>
  );
};

export default MenuSingleItemModal;
